import rootSlice from './slice';

const trendingPeopleReducer = rootSlice.reducer;

export default trendingPeopleReducer;
